import { render } from "./CreateUpdateComponent.vue?vue&type=template&id=cd9d25a8"
import script from "./CreateUpdateComponent.vue?vue&type=script&lang=js"
export * from "./CreateUpdateComponent.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/tesoreria_tolima/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__